import React, { useContext } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { PapiGallection } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useEffectOnceOnMount } from '@wix/da-shared-react/pkg/utils/hooks/useEffectOnceOnMount';
import DesktopGallectionSimpleView from './DesktopGallectionSimpleView';
import MobileGallectionSimpleView from './MobileGallectionSimpleView';
import { useNonEmptyGallectionFolders } from '../hooks/useGallectionFolders';

export type Props = {
  currentFolder?: PapiGallection;
  setCurrentlyViewedFolderId: (folderId: number) => void;
};

const GallectionSimpleView: React.FC<
  Props & RouteComponentProps<{ folderId?: string }>
> = ({
  currentFolder,
  match: {
    params: { folderId },
  },
}) => {
  const isMobile = useContext(MobileContext);
  const { folders } = useNonEmptyGallectionFolders();

  useEffectOnceOnMount(() => {
    if (!folderId) {
      return;
    }

    const intFolderId = +folderId;
    const parentId = folders.find(
      item => item.folderId === intFolderId
    )?.parentId;
    const anchor = document.getElementById('sub-folder-gallery');

    if (!parentId || !anchor) {
      return;
    }

    anchor.scrollIntoView();
  });

  if (isMobile) {
    return <MobileGallectionSimpleView currentFolder={currentFolder} />;
  }
  return <DesktopGallectionSimpleView currentFolder={currentFolder} />;
};
GallectionSimpleView.displayName = 'GallectionSimpleView';

export default withRouter(GallectionSimpleView) as React.ComponentType<Props>;
